import request from './request'

// 获取单门课程详情
export function getCourseDetail(courseKey) {
    return request({
        url: '/course/getDetail',
        method: 'get',
        params: { courseKey }
    })
}

// 保存课程访问记录
// api/course.js
export function saveCourseVisit(data){
    return request({
        url:'/course/saveVisit',
        method:'post',
        data
    })
}

// 获取用户全部课程进度
export function getUserProgress() {
    return request({
        url: '/course/getUserProgress',
        method: 'get'
    })
}